import { combineReducers } from "redux";

import { loggedOut } from "./actions";
import account from "./reducers/account";
import accountList from "./reducers/accountList";
import actionList from "./reducers/actionList";
import admin from "./reducers/admin";
import assessment from "./reducers/assessment";
import company from "./reducers/company";
import contactPerson from "./reducers/contactPerson";
import criteriaCatalog from "./reducers/criteriaCatalog";
import facility from "./reducers/facility";
import history from "./reducers/history";
import inspection from "./reducers/inspection";
import notes from "./reducers/notes";
import occupation from "./reducers/occupation";
import prequalification from "./reducers/prequalification";
import providingFields from "./reducers/providingFields";
import requirements from "./reducers/requirements";
import specialist from "./reducers/specialist";
import walker from "./reducers/walker";
import xml from "./reducers/xml";

const appReducer = combineReducers({
  account,
  accountList,
  company,
  contactPerson,
  facility,
  specialist,
  providingFields,
  prequalification,
  actionList,
  admin,
  history,
  walker,
  inspection,
  assessment,
  criteriaCatalog,
  notes,
  occupation,
  requirements,
  xml,
});

// Logout hands every slice `undefined`, so each one falls back to its initial state.
export default function rootReducer(state, action) {
  return appReducer(action.type === loggedOut.type ? undefined : state, action);
}
